export const spacing = {
    2: "0.5rem",
    3: "0.75rem",
    4: "1rem",
    5: "1.125rem",
    6: "1.25rem",
    7: "1.375rem",
    8: "1.5rem",
    9: "1.75rem",
    10: "2rem",
    11: "2.25rem",
    100: "7rem",
}